import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const FitnessLifestyleCoursePage: React.FC = () => {
  const fitnessData = {
    title: "Bachelor of Science in Fitness & Lifestyle Medicine",
    shortName: "B.Sc FLM",
    duration: "3 Years",
    description: "A comprehensive program focusing on fitness management, lifestyle medicine, wellness coaching, and preventive healthcare through exercise and nutrition.",
    overview: "B.Sc Fitness & Lifestyle Medicine prepares students to become fitness professionals and lifestyle medicine practitioners who promote health through exercise, nutrition, and lifestyle interventions. The program covers exercise physiology, nutrition science, wellness coaching, fitness assessment, and disease prevention. Students learn to design fitness programs, counsel clients on healthy lifestyles, and work in preventive healthcare settings.",
    eligibility: [
      "Completed 10+2 with Physics, Chemistry, and Biology/Mathematics",
      "Minimum 50% aggregate marks (45% for SC/ST/OBC)",
      "Age: 17-25 years",
      "Physical fitness and sports background preferred",
      "Interest in health and wellness",
      "Good communication skills"
    ],
    careerProspects: {
      roles: [
        "Fitness Trainer",
        "Lifestyle Medicine Practitioner",
        "Wellness Coach",
        "Exercise Physiologist",
        "Nutrition Consultant",
        "Corporate Wellness Manager",
        "Sports Medicine Assistant",
        "Health Promotion Specialist",
        "Fitness Program Director",
        "Preventive Healthcare Coordinator"
      ],
      industries: [
        "Fitness Centers and Gyms",
        "Wellness Centers",
        "Corporate Wellness Programs",
        "Healthcare Facilities",
        "Sports Medicine Clinics",
        "Preventive Medicine Centers",
        "Health Resorts and Spas",
        "Educational Institutions",
        "Government Health Programs",
        "Online Fitness Platforms"
      ],
      averageSalary: "₹3-7 LPA (varies by experience and specialization)",
      topRecruiters: [
        "Gold's Gym",
        "Cult.fit",
        "Talwalkars",
        "Fitness First",
        "Apollo Hospitals",
        "Fortis Healthcare",
        "Corporate Wellness Companies",
        "Sports Authority of India",
        "Health Insurance Companies",
        "Wellness Startups"
      ]
    },
    curriculum: [
      {
        year: 1,
        subjects: [
          "Human Anatomy and Physiology",
          "Exercise Science Fundamentals",
          "Basic Nutrition",
          "Health Assessment",
          "First Aid and CPR",
          "Communication Skills",
          "Psychology of Health Behavior",
          "Introduction to Fitness Training"
        ]
      },
      {
        year: 2,
        subjects: [
          "Exercise Physiology",
          "Advanced Nutrition",
          "Strength and Conditioning",
          "Cardiovascular Fitness",
          "Lifestyle Medicine Principles",
          "Wellness Coaching",
          "Injury Prevention",
          "Fitness Program Design"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Exercise Prescription",
          "Clinical Exercise Testing",
          "Chronic Disease Management",
          "Corporate Wellness",
          "Research Methods",
          "Business Management",
          "Internship",
          "Professional Certification Preparation"
        ]
      }
    ],
    admissionProcess: [
      "Apply to colleges offering B.Sc FLM",
      "Entrance examination or merit-based selection",
      "Physical fitness assessment",
      "Document verification",
      "Medical fitness certificate",
      "Fee payment and admission",
      "Orientation program",
      "Begin academic and practical training"
    ],
    topColleges: [
      {
        name: "Lakshmibai National Institute of Physical Education",
        location: "Gwalior, Madhya Pradesh",
        fees: "₹50,000 PA",
        ranking: "National Institute"
      },
      {
        name: "Lovely Professional University",
        location: "Punjab",
        fees: "₹1.8 LPA",
        ranking: "Private University"
      },
      {
        name: "Amity University",
        location: "Noida, Uttar Pradesh",
        fees: "₹2.5 LPA",
        ranking: "Private University"
      },
      {
        name: "Jindal Institute of Behavioral Sciences",
        location: "Sonipat, Haryana",
        fees: "₹3 LPA",
        ranking: "Specialized Institute"
      },
      {
        name: "MIT World Peace University",
        location: "Pune, Maharashtra",
        fees: "₹2.2 LPA",
        ranking: "Private University"
      }
    ],
    skills: [
      "Exercise Programming",
      "Fitness Assessment",
      "Motivational Coaching",
      "Nutrition Counseling",
      "Health Screening",
      "Communication Skills",
      "Program Management",
      "Technology Proficiency",
      "Customer Service",
      "Safety Protocols",
      "Data Analysis",
      "Behavior Modification"
    ],
    futureScope: "The fitness and wellness industry is booming with increasing health awareness. Future opportunities include digital fitness coaching, wearable technology integration, corporate wellness programs, and specialization in areas like geriatric fitness, post-rehabilitation training, and lifestyle medicine for chronic diseases. The integration of AI and virtual reality in fitness is creating new career possibilities.",
    faqs: [
      {
        question: "What is lifestyle medicine?",
        answer: "Lifestyle medicine is a medical approach that uses lifestyle interventions like exercise, nutrition, stress management, and sleep optimization to prevent, treat, and reverse chronic diseases."
      },
      {
        question: "Can I start my own fitness business?",
        answer: "Yes, many graduates start their own fitness centers, become personal trainers, or launch online fitness platforms. The program includes business management components to prepare for entrepreneurship."
      },
      {
        question: "What certifications can I pursue?",
        answer: "Popular certifications include ACE Personal Trainer, NASM, ACSM, NSCA, and specialized certifications in areas like yoga, pilates, or sports-specific training."
      },
      {
        question: "Is there scope for research in this field?",
        answer: "Yes, there's significant research opportunity in exercise science, nutrition, preventive medicine, and fitness technology. Many graduates pursue higher studies and research careers."
      },
      {
        question: "What's the difference from a regular gym trainer course?",
        answer: "This is a comprehensive degree program covering medical aspects, lifestyle medicine, research methods, and professional practice, unlike short-term certification courses."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {fitnessData.title} ({fitnessData.shortName})
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={fitnessData} />
      </div>
    </div>
  );
};

export default FitnessLifestyleCoursePage;